import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import env from './../../environments/environment'
import appConstants from './../../constants/appConstants'
import UserProfileService from './../../shared/services/UserProfile.service'
import { getName } from './../../shared/utilities/getName.function'

import './AgentHeadshot.scss'

const AgentHeadshot = props => {
  const [headshot, setHeadshot] = useState(UserProfileService.getHeadshot())

  useEffect(() => {
    const onHeadshotChanged = () => setHeadshot(UserProfileService.getHeadshot())
    window.addEventListener('usabg:headshot-changed', onHeadshotChanged)
    return () => window.removeEventListener('usabg:headshot-changed', onHeadshotChanged)
  }, [])

  const history = useHistory(),
    name = {
      u_nickname: UserProfileService.get('u_nickname'),
      u_fname: UserProfileService.get('u_fname'),
      u_lname: UserProfileService.get('u_lname'),
    }

  return (
    <div className='AgentHeadshotComponent'>
      <div onClick={() => history.push('/account-profile')} style={{ padding: 0 }}>
        <figure style={{ width: '38px', height: '38px', margin: 'auto' }}>
          <img
            src={headshot}
            alt='My Profile'
            title='My Profile'
            className='img-fluid d-block headshot-ratio'
            style={{ objectFit: 'cover' }}
          />
        </figure>
        <div className='profile-name'>{getName(name)}</div>
      </div>
    </div>
  )
}

export default AgentHeadshot
